import { render, staticRenderFns } from "./FooterSide.vue?vue&type=template&id=3502d510"
import script from "./FooterSide.vue?vue&type=script&lang=js"
export * from "./FooterSide.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports